import { cva } from "class-variance-authority"

export const inputFieldVariants = cva(
  `flex h-10 w-full rounded bg-input-field-dropdown-primary px-3 py-2 text-general-primary-text font-medium-400 file:mr-2 file:border-0 file:border-r file:bg-transparent file:text-sm file:font-medium file:text-general-primary-text placeholder:text-general-secondary-label focus:outline-none focus-visible:outline-2 disabled:cursor-not-allowed disabled:bg-button-inactive disabled:text-general-secondary-label`,
  {
    variants: {
      error: {
        true: "outline outline-1 outline-general-red",
      },
      success: {
        true: "outline outline-1 outline-general-green",
      },
      v2: {
        true: `border-none bg-interaction-field text-icon-general-primary transition-colors placeholder:text-icon-general-secondary hover:bg-interaction-field-hovered focus-visible:bg-interaction-field-selected focus-visible:outline-1 focus-visible:outline-offset-0 focus-visible:outline-semantic-interaction-selected disabled:text-icon-general-disabled disabled:placeholder:text-icon-general-disabled`,
      },
    },
  }
)
